import { ReactElement } from 'react';

const FORMULA = 'CO';
const SUB_SCRIPT = 2;

const EmissionLabel = (): ReactElement => (
  <>
    {FORMULA}

    <sub>
      {SUB_SCRIPT}
    </sub>
  </>
);

export default EmissionLabel;
